export const en = {
    title: `Dashboard`,
    welcome: `Welcome back, {name}!`,
};
//# sourceMappingURL=en.js.map